<template>
    <div>
        <div class="text-muted mb-1">
            <em class="fa fa-spinner mr-1"></em>
            <span class="field">
                {{
                    $t('feed.checkin.reach_the_goal', {
                        value: progress.to * 100 || 0,
                    })
                }}
            </span>
        </div>
        <div class="text-muted mb-1">
            <em class="fa fa-refresh mr-1"></em>
            <span class="field">
                {{ $t('feed.checkin.realized_value') }}:
                {{ value.to || 2 }}
            </span>
        </div>
        <div class="text-muted mb-1" v-if="satisfaction && satisfaction.to">
            <span class="field"> {{ $t('checkIn.howAmIFeeling') }}: </span>
            <strong>
                <i :class="['fa fa-lg', smileIconClass(satisfaction.to)]" :title="$t(smileStatus(satisfaction.to))"></i>
            </strong>
        </div>
        <div v-if="comments && comments.to" class="mb-1">
            <span class="field">{{ $t('checkIn.generalComments') }}: </span>
            <div v-html="comments.to" class="key-result-comment"></div>
        </div>

        <div v-if="difficulties && difficulties.to">
            <span class="field">{{ $t('checkIn.difficultiesFound') }}: </span>
            <div v-html="difficulties.to" class="key-result-comment"></div>
        </div>
    </div>
</template>

<script>
import { smilesClassesMixin } from '@/mixins'

export default {
    name: 'LogDetails',
    props: {
        details: {
            type: Array,
            required: true,
        },
    },
    mixins: [smilesClassesMixin],
    computed: {
        value() {
            return this.getDetail(this.details, 'value')
        },
        progress() {
            return this.getDetail(this.details, 'progress')
        },
        satisfaction() {
            return this.getDetail(this.details, 'satisfaction')
        },
        comments() {
            return this.getDetail(this.details, 'comments')
        },
        difficulties() {
            return this.getDetail(this.details, 'difficulties')
        },
    },
    methods: {
        getDetail(details, item) {
            return details.find((element) => element['field'] === item)
        },
    },
}
</script>

<style scoped>
.key-result-comment ::v-deep p {
    margin: 0;
}
</style>
